import { ToppingsCategoryItem } from '../store/toppingsCategoryItem/api/interface';

const parseEffortScore = (value?: number | string | null): number => {
  const parsed = parseInt(String(value ?? ''), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 10;
};

export const fillToppingCategoryItemState = (state: ToppingsCategoryItem) => {
  const reqBody = {
    id: state.id ?? '',
    toppingCategoryId: state?.toppingCategoryId ?? '',
    additionalToppingCategoryIds: state?.additionalToppingCategoryIds ?? [],
    labelEn: state?.labelEn ?? '',
    labelAr: state?.labelAr ?? '',
    code: state?.code ?? '',
    descriptionEn: state?.descriptionEn ?? '',
    descriptionAr: state?.descriptionAr ?? '',
    price: state?.price ?? '',
    discountedPrice: state?.discountedPrice ?? '',
    effortScore: parseEffortScore(state?.effortScore),
    previewUrl: state?.previewUrl ?? '',
    position: state?.position ?? '',
    deliveryDayGap: state?.deliveryDayGap ?? '0',
    hasColor: state?.hasColor,
    isBig: state?.isBig === true,
    // isNew: state?.isNew,
    activeState: state?.activeState,
    shapeItems: state?.toppingShapeImages?.map((item) => {
      return {
        shapeId: item?.shapeId ?? '',
        top: item?.top ?? '',
        front: item?.front ?? '',
      };
    }),
  };

  return reqBody;
};
